<li class="side-nav-item" routerLinkActive="side-nav-item--active">
  @if (navItem.path) {
    <a
      data-track
      [routerLink]="navItem.path"
      [queryParams]="navItem.queryParams"
      (click)="hide()"
      class="side-nav-item__link"
    >
      <ng-container *ngTemplateOutlet="actionContentTemplate" />
    </a>
  } @else {
    <button data-track class="side-nav-item__button" (click)="select()">
      <ng-container *ngTemplateOutlet="actionContentTemplate" />
    </button>
  }

  <ng-template #actionContentTemplate>
    @if (navItem.icon) {
      <span class="side-nav-item__icon">
        <ftr-icon [icon]="navItem.icon" align="TextBottom" gapRight="Small" />
      </span>
    }
    <span class="side-nav-item__title">{{ navItem.title }}</span>
  </ng-template>
</li>
